import { Button } from '@/components/ds2'
import { formatCount } from '../results/format'
import { FACTORING_BATCH_MIN, FACTORING_BATCH_MIN_SENTENCE } from '../results/refusalWords'

interface FactoringCardProps {
    provider: string
    /** The drafts a batch could take now (`factoringEligibilityOf`): sent, batched and issue-blocked ones are not counted. */
    eligibleCount: number
    onReview: () => void
    onNotNow: () => void
}

/** What the offer says: nothing eligible, too few for a batch, or the batch it offers. */
const offerOf = (eligibleCount: number): string => {
    if (eligibleCount === 0) return 'No invoice is eligible for a factoring batch right now.'
    if (eligibleCount < FACTORING_BATCH_MIN) return FACTORING_BATCH_MIN_SENTENCE
    return `Would you like to submit ${formatCount(eligibleCount)} eligible invoices as a batch?`
}

/**
 * The chat's factoring offer (v17 flow 15) whenever a factoring connection is on. Its button is disabled while fewer drafts are eligible
 * than a batch takes, so the offer never leads to a batch the prepare card refuses.
 */
export const FactoringCard = ({ provider, eligibleCount, onReview, onNotNow }: FactoringCardProps) => (
    <section aria-label="Factoring batch" className="my-3 flex flex-col gap-2 rounded-xl border border-accent-soft bg-accent-soft/40 p-3 text-xs">
        <strong className="text-foreground">Factoring connected · {provider}</strong>
        <p className="text-foreground-muted">{offerOf(eligibleCount)}</p>
        <div className="flex items-center gap-2">
            <Button size="sm" variant="outline" onClick={onReview} disabled={eligibleCount < FACTORING_BATCH_MIN}>
                Review factoring batch
            </Button>
            <Button size="sm" variant="ghost" onClick={onNotNow}>
                Not now
            </Button>
        </div>
    </section>
)
